__turbopack_context__.v({
  "button": "SampleCarouselControls-module-scss-module__16citq__button",
  "container": "SampleCarouselControls-module-scss-module__16citq__container",
  "enter": "SampleCarouselControls-module-scss-module__16citq__enter",
  "exit": "SampleCarouselControls-module-scss-module__16citq__exit",
  "fade-in": "SampleCarouselControls-module-scss-module__16citq__fade-in",
  "fade-out": "SampleCarouselControls-module-scss-module__16citq__fade-out",
  "fade-out-80": "SampleCarouselControls-module-scss-module__16citq__fade-out-80",
  "icon": "SampleCarouselControls-module-scss-module__16citq__icon",
  "slide-in-from-bottom": "SampleCarouselControls-module-scss-module__16citq__slide-in-from-bottom",
  "slide-in-from-left": "SampleCarouselControls-module-scss-module__16citq__slide-in-from-left",
  "slide-in-from-right": "SampleCarouselControls-module-scss-module__16citq__slide-in-from-right",
  "slide-in-from-top": "SampleCarouselControls-module-scss-module__16citq__slide-in-from-top",
  "slide-out-to-bottom": "SampleCarouselControls-module-scss-module__16citq__slide-out-to-bottom",
  "slide-out-to-left": "SampleCarouselControls-module-scss-module__16citq__slide-out-to-left",
  "slide-out-to-right": "SampleCarouselControls-module-scss-module__16citq__slide-out-to-right",
  "slide-out-to-top": "SampleCarouselControls-module-scss-module__16citq__slide-out-to-top",
  "zoom-in": "SampleCarouselControls-module-scss-module__16citq__zoom-in",
  "zoom-out": "SampleCarouselControls-module-scss-module__16citq__zoom-out",
});
